var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"min-width":"100% !important","min-height":"100% !important"},attrs:{"src":(_vm.publicPath + "Unity/index.html"),"frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }